export enum ClimaticStatusEnum {
  Low = 'Faible',
  Normal = 'Normal',
  Strong = 'Fort',
}

export enum ClimaticStatusCodeEnum {
  Low = 'F',
  Normal = 'N',
  Strong = 'TF',
}
